// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2f5KW","col":"styles_col__304c5","fulfillmentStatus":"styles_fulfillmentStatus__21_QK","emailCol":"styles_emailCol__2FXlE"};